<template>
    <header>
      <h1>Plant Protein Structure Annotation Project</h1>
      <p>The Plant Protein Structure Annotation Project (PPSAP) is an initiative dedicated to annotating plant genes based on protein structures. Since protein structures are more evolutionarily conserved than sequences, this approach enables the identification of genes with conserved structures but significant sequence divergence—genes that are difficult to detect using sequence-based (e.g., BLASTp) or profile-based (e.g., HMM) methods. This provides valuable clues for functional studies of previously uncharacterized proteins.</p>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css">
    </header>
    <div class="combobox">
      <div class="search-div">
        <div class="select-group">
        <!-- 输入框 -->
          <input type="text" v-model="searchQuery" placeholder="Enter Search Query" @focus="showDropdown = true" @blur="onBlur">
          <button @click="performSearch">Search</button>
        </div>
        <!-- 下拉菜单 -->
        <ul class="dropdown" v-show="showDropdown && filteredOptions.length > 0">
          <li
            v-for="(option, index) in filteredOptions"
            :key="index"
            @mousedown="selectOption(option)"
          >
            {{ option }}
          </li>
        </ul>
      </div>
      <p>Example: Q8RXZ6, AT2G41950, Os10g0351100</p>
    </div>
    <router-view></router-view>

</template>

<script>
export default {
  data() {
    return {
      searchQuery: '',         // 输入框内容
      showDropdown: false,     // 是否显示下拉框
      options: [],             // 所有选项（来自后台）
      isLoading: false         // 加载状态（可选）
    };
  },
  computed: {
    // 根据输入内容过滤选项
    filteredOptions() {
      if (!this.searchQuery.trim()) return this.options;
      const keyword = this.searchQuery.toLowerCase();
      return this.options.filter(item =>
        item.toLowerCase().includes(keyword)
      );
    }
  },

  watch: {
    searchQuery(val) {
      if (val.length >= 5) {
        this.debouncedFetch(val);
      } else {
        this.options = [];
      }
    }
  },
  created() {
    this.debouncedFetch = this.debounce(this.fetchOptionsFromAPI, 300); // 防抖
  },
  methods: {
    async fetchOptionsFromAPI(query) {
      try {
        const response = await fetch(`https://ai-biolab.cn/api/uniprot?q=${query}`);
        // const response = await fetch(`http://localhost:3000/api/uniprot?q=${query}`);
        this.options = await response.json();
      } catch (error) {
        console.error('获取下拉选项失败:', error);
      }
    },
    debounce(fn, delay) {
      let timer = null;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
    // 选中某个选项
    selectOption(option) {
      this.searchQuery = option;
      this.showDropdown = false;
      this.$emit('select', option); // 可以传递给父组件
    },

    // 外部点击关闭下拉框
    onBlur() {
      // 延迟执行确保 click 事件先触发
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },

    performSearch() {
      console.log('执行搜索:', this.searchQuery);
      this.$router.push({ name: 'SearchResultTable', query: { q: this.searchQuery } });
    },
  }
}

</script>

<style >
html, body {
  height: 100%;
  margin: 0;
}

#app {
  font-family: Arial, sans-serif;
  text-align: center;
  margin: 0 auto; /* 使用 auto 值让左右外边距自动分配，使元素水平居中 */
  min-height: 100vh; /* 确保至少占据整个视口的高度 */
  width: 80%;
  height: 100%;
  box-sizing: border-box; /* 确保 padding 不会增加元素的实际宽度和高度 */
}

/* 确保宽度是100% */
#app .router-view {
  width: 100%;
  margin: 0 auto;
}

header {
  margin-bottom: 20px;
}

p {
  text-align: left;
}

.combobox p {
  margin-top: 0;
  color: blue;
  font-size: 0.85em;
}

.combobox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
  margin: 0 auto;
}

.search-div {
  position: relative;
  width: 100%;
}

.select-group {
  position: relative; 
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}

.select-group input {
  width: 100%;
  padding: 8px 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
}

.select-group button {
  padding: 8px 16px;
  margin-left: 8px;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: white;
  z-index: 1000;
  list-style: none;
  margin: 0;
  padding: 0;
  border-top: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dropdown li {
  padding: 10px;
  cursor: pointer;
}

.dropdown li:hover {
  background-color: #f2f2f2;
}
</style>